import { connect } from 'react-redux';
import { loadingManagementApi } from 'feature/loading-management/loadingManagementApi';
import * as R from 'ramda';

import {
  createNewCarrierAuth,
  getEnabledOptions,
  getStoreValueByProp,
  getViewBySelection,
  setSubmittingBatch,
} from '../../store/createNewCarrierAuthSlice';
import SummaryStep from './Submit';

const mapState = R.applySpec({
  authorizationBy: getStoreValueByProp(['authorizationBy']),
  enabledOptions: getEnabledOptions,
  supplier: getStoreValueByProp(['supplier']),
  viewBySelection: getViewBySelection,
});

const mapDispatch = {
  createNewCarrierAuth,
  refreshCarrierAuthorizationsListView: () =>
    loadingManagementApi.util.invalidateTags(['CarrierAuthorizationList']),
  setSubmittingBatch,
};

export default connect(mapState, mapDispatch)(SummaryStep);
